import React, {Fragment} from 'react'
import flatstore from 'flatstore';
import FarmshopList from './FarmshopList'
import FarmshopDetail from './FarmshopDetail'
import FarmshopFeedback from './FarmshopFeedback'
import {includes, isNil} from 'lodash';
import { useTranslation } from 'react-i18next';
import { currentLang } from '../../utils/functions';
import { siteInfo } from './../../utils/config';
import { useParams } from 'react-router-dom';


const Farmshop = () => {
	let {slug} = useParams();
	if(isNil(slug)){
		return (<FarmshopList />)
	}else if(slug=='feedback'){
		return (<FarmshopFeedback />)
	}else{
		return (<FarmshopDetail slug={slug} />)
	}
}

export default Farmshop
